import React from 'react'
import styled from '@emotion/styled';
import { Box, Button, Container, Grid } from '@mui/material';
import successful from '../../../../assets/successful.png';
import key from '../../../../assets/key.png';
import mobile from '../../../../assets/mobile.png';
import laptop from '../../../../assets/laptop.png';
import tv from '../../../../assets/tv.png';
import Heading from '../../../Components/Heading';
import Paragraph from '../../../Components/Paragraph';

const Wrapper = styled.div`
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 60px;
  color: #fff;
`;
const UpperBox = styled(Box)`
  background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
  padding: 2px;
  border-radius: 40px;
    margin-top: 40px;
  width: 100%;
`;
const StyledButton = styled(Button)`
  text-transform: none;

  color: white;
  font-family: "PoppinsM";
  width: 100%;
  border-radius: 40px !important;
  font-size: 16px;
  font-family: Bold !important;
  padding: ${(props) => (props.p ? props.p : "6px 20px")};
  border: 3px solid #220154;

  &:hover {
    background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
    color: white;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @media(max-width: 599px) {
    font-size: 14px !important;
    padding: 7px 9px !important;
  }
`;
const Card = styled(Box)`
  background: #080411;
  border-radius: 20px;
  padding: 24px;
  border: 1px solid #1f1f2e;
  width: 100%;
  backdrop-filter: blur(10px);
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #1a1825;

  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.span`
  color: #9a9aa5;
  font-size: 15px;
`;

const Value = styled.span`
  font-size: 15px;
  color: #ffffff;
`;

const BlueValue = styled(Value)`
  color: #4aa8ff;
  cursor: pointer;
`;

const PurpleValue = styled(Value)`
  color: #b892ed;
`;
const ImageWrapperBox = styled(Box)`
  position: relative;
  width: 100%;
  margin-top: 30px;
  min-height: 130px;
  padding: 20px;
  overflow: hidden;
  border-radius: 20px;
  cursor: pointer;
  background: #070616;
  border: 0.5px solid #222;
  
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 
    0 2px 3px 0 #FFF inset,
    0 0 116.1px -53px #7300FF inset,
    0 41px 66.9px -33px #CB60FA inset,
    0 4px 20px rgba(0, 0, 0, 0.3), !important;
    
 animation: smoothMovingShadow 3s ease-in-out infinite !important; 
  &:hover {
   
    transform: translateY(-8px);
    box-shadow: 
      0 2px 2px 0 #FFF inset,
      0 0 116.1px -53px #7300FF inset,
      0 41px 66.9px -33px #CB60FA inset,
      0 15px 40px rgba(115, 0, 255, 0.4),
      0 8px 25px rgba(203, 96, 250, 0.3);
  }

  @keyframes smoothMovingShadow {
    0% {
      box-shadow: 
        0 2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    25% {
      box-shadow: 
        1px 0 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    50% {
      box-shadow: 
        0 -2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    75% {
      box-shadow: 
        -1px 0 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    100% {
      box-shadow: 
        0 2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
  }
`;


const ActivationTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;

  span {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    opacity: 0.9;
  }
`;

const ActivationSubtitle = styled.div`
  font-size: 13px;
  color: #99A1AF;

`;

const CodeInputBox = styled.div`
  margin-top: 15px;
  padding: 10px 20px;
  border: 1px solid rgba(173, 94, 255, 0.6);
  border-radius: 12px;
  background: rgba(7, 4, 17, 0.3);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CodeText = styled.span`
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 3px;
   background: linear-gradient(115deg, #7300FF -10%, #a860ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
`;

const CopyBtn = styled.div`
  width: 34px;
  height: 34px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  border: 1px solid rgba(255,255,255,0.12);

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

const HintText = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #b8b8c7;
  font-size: 13px;
  opacity: 0.9;
`;

const Card2 = styled(Box)`
  padding: 16px 22px;
  border-radius: 10px;
  height: 80%;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  backdrop-filter: blur(4px);

  background: ${({ active }) =>
    active ? 'rgba(168, 96, 255, 0.12)' : 'rgba(255, 255, 255, 0.03)'};

  border: 1px solid
    ${({ active }) =>
      active ? 'rgba(168, 96, 255, 0.6)' : 'rgba(255, 255, 255, 0.08)'};

  box-shadow: ${({ active }) =>
    active ? '0 0 12px rgba(168, 96, 255, 0.45)' : 'none'};

`
const PaymentSuccessful = () => {
  return (
    <Wrapper>
      <Container maxWidth="xl">
        <Grid container justifyContent="center" alignItems="center" direction="column">
          <img 
            src={successful} 
            alt="Payment Successful" 
            style={{ maxWidth: '80px', marginBottom: '20px', marginTop: '50px', width: '100%', height: 'auto' }} 
          />

          <Heading style={{ fontSize: '40px', marginBottom: '10px' }}>
            Payment Successful!
          </Heading>

          <Paragraph style={{ fontWeight: '600', marginBottom: '6px' }}>
            Welcome to Shadow Node dVPN Premium
          </Paragraph>

          <Paragraph>
            Transaction confirmed. Your account is now active.
          </Paragraph>
        </Grid>

        {/* Order Details Card */}
        <Grid container justifyContent="center" mt={3}>
          <Grid item xs={12} md={7} lg={6}>
            <Card>
              <Paragraph style={{marginBottom: '15px' }}>
                Order Details
              </Paragraph>
              <Row>
                <Label>Plan</Label>
                <Value>1 Year</Value>
              </Row>
              <Row>
                <Label>Duration</Label>
                <Value>12 months</Value>
              </Row>
              <Row>
                <Label>Payment Method</Label>
                <Value>Crypto</Value>
              </Row>
              <Row>
                <Label>Trx Hash</Label>
                <BlueValue>0x7d*****fc80</BlueValue>
              </Row>
              <Row>
                <Label>Amount Paid</Label>
                <PurpleValue>$50.00</PurpleValue>
              </Row>
            </Card>
                <ImageWrapperBox>
              <ActivationTitle>
                <img src={key} alt="Your Key" style={{ maxWidth: '40px', width: '100%', height: 'auto' }} />
                <Box style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{fontWeight:'normal'}}>Your Activation Code</span>
                <ActivationSubtitle>
                Use this to activate your VPN account
              </ActivationSubtitle>
              </Box>
              </ActivationTitle>
              <CodeInputBox>
                <CodeText>BZMP-H1WQ-VIR8-7J1I8</CodeText>

                <CopyBtn>
                  <svg width="20" height="20" fill="#fff" opacity="0.85" viewBox="0 0 24 24">
                    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 
                            .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 
                            2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                  </svg>
                </CopyBtn>
              </CodeInputBox>

              <HintText>
                <span style={{ fontSize: "16px" }}>💡</span>
                Save this code – you'll need it to activate the VPN on your devices
              </HintText>
              </ImageWrapperBox>
              <Card style={{ marginTop: '50px' }}>
            <Paragraph style={{ marginBottom: '10px' }}>
              Download Shadow Node dVPN
            </Paragraph>

            <ActivationSubtitle>
              Get started by downloading our app for your devices
            </ActivationSubtitle>

            <Grid container spacing={2} mt={2}>
              
              {/* Mobile */}
              <Grid item xs={12} md={4}>
                <Card2>
                  <img 
                    src={mobile} 
                    alt="Mobile" 
                    style={{ maxWidth: '26px', height: 'auto', marginBottom: '12px' }} 
                  />
                  <Value>Mobile</Value>
                  <ActivationSubtitle>iOS & Android</ActivationSubtitle>
                </Card2>
              </Grid>

              {/* Desktop */}
              <Grid item xs={12} md={4}>
                <Card2>
                  <img 
                    src={laptop} 
                    alt="Desktop" 
                    style={{ maxWidth: '35px', height: 'auto', marginBottom: '17px' }} 
                  />
                  <Value>Desktop</Value>
                  <ActivationSubtitle>Windows & Mac</ActivationSubtitle>
                </Card2>
              </Grid>

              {/* TV */}
              <Grid item xs={12} md={4}>
                <Card2>
                  <img 
                    src={tv} 
                    alt="TV" 
                    style={{ maxWidth: '35px', height: 'auto', marginBottom: '12px' }} 
                  />
                  <Value>TV</Value>
                  <ActivationSubtitle>Smart TV & More</ActivationSubtitle>
                </Card2>
              </Grid>

            </Grid>
              </Card>
                  <Card style={{ marginTop: '50px', padding: '28px' }}>
                    <Paragraph style={{ marginBottom: '14px', fontSize: '18px', fontWeight: '600' }}>
                      What's Next?
                    </Paragraph>

                    {/* STEP 1 */}
                    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #8A3CFF, #4B2BFF)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '15px',
                          fontWeight: '600',
                        }}
                      >
                        1
                      </Box>

                      <Box>
                        <Value style={{ fontSize: '15px', fontWeight: "600" }}>Download the app</Value>
                        <ActivationSubtitle style={{ marginTop: '3px' }}>
                          Choose your platform and download Shadow dVPN
                        </ActivationSubtitle>
                      </Box>
                    </Box>

                    {/* STEP 2 */}
                    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #8A3CFF, #4B2BFF)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '15px',
                          fontWeight: '600',
                        }}
                      >
                        2
                      </Box>

                      <Box>
                        <Value style={{ fontSize: '15px', fontWeight: "600" }}>Enter activation code</Value>
                        <ActivationSubtitle style={{ marginTop: '3px' }}>
                          Use the code above to activate your premium account
                        </ActivationSubtitle>
                      </Box>
                    </Box>

                    {/* STEP 3 */}
                    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #8A3CFF, #4B2BFF)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '15px',
                          fontWeight: '600',
                        }}
                      >
                        3
                      </Box>

                      <Box>
                        <Value style={{ fontSize: '15px', fontWeight: "600" }}>Connect to a server</Value>
                        <ActivationSubtitle style={{ marginTop: '3px' }}>
                          Select from 100+ server locations worldwide
                        </ActivationSubtitle>
                      </Box>
                    </Box>

                    {/* STEP 4 */}
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #8A3CFF, #4B2BFF)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '15px',
                          fontWeight: '600',
                        }}
                      >
                        4
                      </Box>

                      <Box>
                        <Value style={{ fontSize: '15px', fontWeight: "600" }}>Browse securely</Value>
                        <ActivationSubtitle style={{ marginTop: '3px' }}>
                          Enjoy fast, private, and secure internet access
                        </ActivationSubtitle>
                      </Box>
                    </Box>
                  </Card>
                  <UpperBox>
                <StyledButton>
                    View My Account
                </StyledButton>
                </UpperBox>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default PaymentSuccessful;
